import type { FC } from 'react';
import type { TablesFooterProps } from './tables-footer.types';

import { Pagination } from 'antd';
import { Divider } from '@chakra-ui-kraud/react';

import styles from './tables-footer.module.scss';

export const TablesFooter: FC<TablesFooterProps> = ({ pageSize, total, page, setQueryParams, onPageChange }) => {
	const onChange = (page: number, pageSize: number) => {
		setQueryParams?.((prev) => ({
			...prev,
			currentPage: page,
			pageSize: pageSize,
		}));
		onPageChange?.(page, pageSize);
	};

	return (
		<div className={styles.footer}>
			<div className={styles.divider}>
				<Divider />
			</div>
			<div className={styles.pagination}>
				<Pagination
					pageSize={pageSize}
					style={{ fontFamily: 'Raleway', fontWeight: '500' }}
					total={total}
					defaultPageSize={32}
					current={page}
					pageSizeOptions={['10', '32', '50', '100']}
					showSizeChanger
					locale={{ items_per_page: '/ стр' }}
					showTotal={(total) => <>Всего {total}</>}
					onChange={onChange}
				/>
			</div>
		</div>
	);
};
